// general imports
import { IconPropsType } from '../types'

const EditIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 19.9963H21M16.5 3.49632C16.8978 3.0985 17.4374 2.875 18 2.875C18.2786 2.875 18.5544 2.92987 18.8118 3.03648C19.0692 3.14308 19.303 3.29934 19.5 3.49632C19.697 3.6933 19.8532 3.92716 19.9598 4.18453C20.0665 4.4419 20.1213 4.71774 20.1213 4.99632C20.1213 5.2749 20.0665 5.55074 19.9598 5.80811C19.8532 6.06548 19.697 6.29934 19.5 6.49632L7 18.9963L3 19.9963L4 15.9963L16.5 3.49632Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default EditIcon
